import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

const ProjectIdeaMoved = ({
  events = [],
  ownerIdea,
}: NotificationContentProps) => {
  return (
    <Trans
      i18nKey="notifications.projectIdeaMoved"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        prevStage: events[0]?.previousLane || "Deleted",
        newStage: events[events.length - 1]?.newLane || "Deleted",
      }}
    />
  );
};

export default ProjectIdeaMoved;
